module.exports = __webpack_public_path__ + "img/P150T_weapon_45.db49a894.png";